'use strict';

import angular from 'angular';

angular.module('observatoireApp')
  .controller('SearchController', ['$scope', '$state', '$stateParams', '$timeout', 'GlobalSearchService',
    function($scope, $state, $stateParams, $timeout, GlobalSearchService) {

      $scope.query         = $stateParams.q || '';
      $scope.displayedQuery = '';
      $scope.isLoading     = false;
      $scope.searched      = false;
      $scope.total         = 0;
      $scope.groups        = [];

      $scope.doSearch = function() {
        if (!$scope.query || $scope.query.trim().length < 2) return;
        $state.go('main.search', { q: $scope.query.trim() }, { reload: true });
      };

      $scope.navigateTo = function(item) {
        $state.go(item.state);
      };

      function runSearch(q) {
        if (!q || q.trim().length < 2) return;
        $scope.isLoading = true;
        $scope.searched  = false;

        GlobalSearchService.fullSearch(q).then(function(result) {
          $scope.displayedQuery = result.query;
          $scope.total          = result.total;
          $scope.groups         = result.groups;
          $scope.searched       = true;
          $scope.isLoading      = false;
        }).catch(function() {
          $scope.isLoading = false;
          $scope.searched  = true;
          $scope.total     = 0;
          $scope.groups    = [];
        });
      }

      if ($scope.query) {
        runSearch($scope.query);
      }
    }
  ]);
